import { CmmdApiError } from "../environments/cmmdApi/transport";
import { isCloudBearerAuthFailure } from "../lib/cloudAuthFailure";

/**
 * Cloud-shell / workspace-proxy preferences bootstrap must not throw CMMD REST
 * auth failures into RootRouteErrorView. Those are product-login recoveries.
 */
export function shouldForceLoginOnCmmdPreferencesError(error: unknown): boolean {
  if (isCloudBearerAuthFailure(error)) return true;
  return error instanceof CmmdApiError && error.kind === "auth";
}
